import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import SchoolList from './SchoolList';
import SchoolDetail from './SchoolDetail';
import SchoolSubscriptionList from './SchoolSubscriptionList';
import BulkInviteCreation from '../Invitation/BulkInviteCreation';

export default class School extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/schools/:schoolId(\d+)/subscriptions" component={SchoolSubscriptionList} />
        <Route path="/schools/:schoolId(\d+)/bulk-invite" component={BulkInviteCreation} />
        <Route path="/schools/:schoolId(\d+)" component={SchoolDetail} />
        <Route exact path="/schools" component={SchoolList} />
        <Redirect to="/schools" />
      </Switch>
    );
  }
}
